import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { replace } from 'redux-router';
import { fetchUserInfoDeferred } from '../actions/Actions';
import {
  IAddress,
  IProductInfo,
  IState,
  IUserInfo,
  Replace
} from '../CustomTypes';

/**
 * Empty page showing address or userInfo depending on if the user has an address set or not
 */
export interface IDispatchProps {
  replace: Replace;
}

export interface IStateProps {
  productInfo?: IProductInfo;
  userInfo?: IUserInfo;
  address?: IAddress;
  b64data?: string;
  __rct?: string;
}

export interface IProps extends IDispatchProps, IStateProps {}

export class UserInfoLandingPage extends React.Component<IProps, {}> {
  public componentWillMount() {
    const { productId } = this.props.productInfo;
    let url = `/products/${productId}/`;
    fetchUserInfoDeferred.promise
      .then(() => {
        if (this.props.address.zipCode && this.props.address.city) {
          url += 'userinfo';
        } else {
          url += 'address';
        }
        if (this.props.b64data) {
          url += `?b64data=${encodeURIComponent(this.props.b64data)}`;
          if (this.props.__rct) {
            url += `&__rct=${this.props.__rct}`;
          }
        } else if (this.props.__rct) {
          url += `?__rct=${this.props.__rct}`;
        }
        this.props.replace(url);
      })
      .catch(() => {
        this.props.replace(`${url}start`);
      });
  }

  public render() {
    return (
      <div className="container checkCode component">
        <div className="col-xs-12">
          <br />
          <h1>Vi laster dine data...</h1>
        </div>
      </div>
    );
  }
}

export default connect<IStateProps, IDispatchProps, {}>(
  (state: IState) => ({
    __rct: state.router.location.query.__rct,
    address: state.address,
    b64data: state.router.location.query.b64data,
    productInfo: state.productInfo,
    userInfo: state.userInfo
  }),
  dispatch => bindActionCreators({ replace }, dispatch)
)(UserInfoLandingPage);



// WEBPACK FOOTER //
// ./src/page-components/UserInfoLandingPage.tsx